import ICONS_DICTIONARY from './IconsDepartment'

const Icon = ({ color, width, height, name }) => (
  <svg width={width} height={height} viewBox="0 0 25 25" fill={color}>
    {ICONS_DICTIONARY[name]}
  </svg>
)

export default Icon
